import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import config from "../../config";
import {
  getLogout,
  username,
  role,
  token,
  roleid,
} from "../Actions/AuthAction";
import { getJobsList } from "../Actions/JobAction";
import Shimmer from "../Common/Shimmer";
import {
  getEmployerList,
  getUniversityList,
  getRecruiterList,
} from "../Actions/AdminAction";
import Select from "react-validation/build/select";
import {
  getCity,
  GetCourses,
  GetSkill,
  getUniversity,
  selectSector,
} from "../Actions/CommonAction";
import CONFIG from "../../config";
import Loader from "../Common/Loader";
import { array } from "yup";
const ListJob = () => {
  const [jobList, setjobList] = useState("");
  const [page, setpage] = useState(1);
  const [totalJobs, settotalJobs] = useState(0);
  const [userrole, setuserrole] = useState("");
  const [employerOptions, setemployerOptions] = useState([]);
  const [employerid, setemployerid] = useState("");

  const [sectorOptions, setsectorOptions] = useState([]);
  const [sectorid, setsectorid] = useState("");

  const [recruiterOptions, setrecruiterOptions] = useState([]);
  const [recruiterid, setrecruiterid] = useState("");
  const [loading, setLoading] = useState(false);

  const [locOptions, setlocOptions] = useState([]);
  const [jobLocation, setjobLocation] = useState([]);
  const [location, setLocation] = useState([]);

  const [courseOptions, setcourseOptions] = useState([]);
  const [courses, setCourses] = useState([]);
  const [putCourses, setPutCourses] = useState([]);

  const [skillOptions, setskillOptions] = useState([]);
  const [skills, setSkills] = useState([]);
  const [putSkills, setPutSkills] = useState([]);

  useEffect(() => {
    setLoading(true);
    const model = {
      page: page,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: sectorid,
      locations: location,
      skills: putSkills,
      courses: putCourses,
    };
    getJobs(model);
    setuserrole(role());
    getEmployerList({
      page: "-1",
      search: "",
      status: 1,
      city: "",
      state: "",
      limit: "",
    }).then((res) => setemployerOptions(res.data));

    getRecruiterList({
      page: "-1",
      search: "",
      status: 1,
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      setrecruiterOptions(res.data);
    });

    selectSector({ status: "" }).then((res) => setsectorOptions(res.data));
    getCity().then((res) => setlocOptions(res.data));
    GetCourses({ status: "" }).then((res) => setcourseOptions(res.data));
    GetSkill({ status: "" }).then((res) => {
      res.data.map((item, index) => (res.data[index].name = item.skillname));
      setskillOptions(res.data);
    });
  }, []);

  const getJobs = (model) => {
    getJobsList(model).then((res) => {
      res.data ? settotalJobs(res.totaldata) : settotalJobs(0);
      setjobList(res.data);
      setLoading(false);
    });
  };
  const changePage = (value) => {
    setLoading(true);
    const truePage = page + value;
    setpage(page + value);
    window.scroll(0, 0);
    setjobList(null);

    const model = {
      page: truePage,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: sectorid,
      locations: location,
      skills: putSkills,
      courses: putCourses,
    };
    getJobs(model);
  };

  const setRecruiter = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);
    const model = {
      page: 1,
      token: token(),
      recruiterid: value,
      employeeid: employerid,
      sector: sectorid,
      locations: location,
      skills: putSkills,
      courses: putCourses,
    };
    setrecruiterid(value);
    getJobs(model);
  };

  const setEmployer = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);
    const model = {
      page: 1,
      token: token(),
      recruiterid: recruiterid,
      employeeid: value,
      sector: sectorid,
      locations: location,
      skills: putSkills,
      courses: putCourses,
    };
    setemployerid(value);
    getJobs(model);
  };

  const clickSector = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);
    const model = {
      page: 1,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: value,
      locations: location,
      skills: putSkills,
      courses: putCourses,
    };
    setsectorid(value);
    getJobs(model);
  };

  const clickSkills = (value) => {
    const arr1 = [];

    value.map((item) => {
      arr1.push(item.skillcode);
    });

    console.log("courses" + arr1);
    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);
    const model = {
      page: 1,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: sectorid,
      locations: location,
      skills: arr1,
      courses: putCourses,
    };
    setSkills(value);
    setPutSkills(arr1);
    getJobs(model);
  };

  const clickLocations = (value) => {
    const arr1 = [];

    value.map((item) => {
      arr1.push(item.district_id);
    });

    console.log("Location" + arr1);

    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);

    const model = {
      page: 1,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: sectorid,
      locations: arr1,
      skills: putSkills,
      courses: putCourses,
    };
    setjobLocation(value);
    setLocation(arr1);
    getJobs(model);
  };

  const clickCourses = (value) => {
    const arr1 = [];

    value.map((item) => {
      arr1.push(item.id);
    });

    console.log("courses" + arr1);

    setLoading(true);
    window.scroll(0, 0);
    setjobList(null);
    const model = {
      page: 1,
      token: token(),
      recruiterid: recruiterid,
      employeeid: employerid,
      sector: sectorid,
      locations: location,
      skills: putSkills,
      courses: arr1,
    };
    setCourses(value);
    setPutCourses(arr1);
    getJobs(model);
  };

  const renderJob = () => {
    return (
      <>
        {jobList.map((item, index) => (
          <div className="card formcard mb-3" key={index}>
            <div className="card-body">
              <div className="d-flex justify-content-between  border-bottom">
                <div className="d-flex justify-content-start">
                  <img
                    src={`${CONFIG.IMAGE_URL}/${item.employee.logo}`}
                    className="company_logo"
                  />
                  <div className="ml-3">
                    <h4 className="mb-0">
                      <Link to={"/jobdetail/" + item.jobid}>
                        {item.jobdesignation}
                      </Link>
                    </h4>
                    <div className="d-flex mb-2">
                      <span className="mr-2">
                        <i className="text-danger fas fa-university mt-2 ml-2"></i>{" "}
                        {item.employee.companyname}
                      </span>
                      <span className="mx-2">
                        <i className="text-danger fas fa-cube mt-2"></i>{" "}
                        {item.sector.sectorname}
                      </span>
                      <span className="mx-2">
                        <i className="text-danger fas fa-clone mt-2"></i>{" "}
                        {item.jobtype}
                      </span>
                    </div>
                    <div className="d-flex mb-2">
                      <span className="mx-2">
                        <i className="text-danger fas fa-map-marker mt-2"></i>{" "}
                        {item.joblocationmaps.map((item, key) => (
                          <>
                            <span className="badge badge-pill badge-secondary mx-1">
                              {item.city.name}
                            </span>{" "}
                          </>
                        ))}
                      </span>

                      <span className="mx-2">
                        <i className="text-danger fas fa-wallet mt-2"></i>{" "}
                        <span className="font-weight-bold">₹</span>
                        {item.costtocompanystart} - {item.costtocompanyend} LPA
                      </span>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div className="header-btn"></div>
              </div>
              <div className="d-flex justify-content-between pt-3 joblisting">
                <div className="col-md-12">
                  <ul>
                    <li>
                      {item.jobskillmap.map((item, key) => (
                        <>
                          <span className="badge badge-pill badge-primary mx-1">
                            {item.skillcode0.skillname}
                          </span>{" "}
                        </>
                      ))}
                    </li>
                    <li
                      className="border-0"
                      dangerouslySetInnerHTML={{
                        __html:
                          item.jobdescription.substring(0, 250) + "...",
                      }}
                    />
                  </ul>
                </div>
                {/* <div className="col-md-2 d-flex align-items-center justify-content-center">
           <div>
           {userrole==5&&<a className="btn btn-primary-custom mx-2 d-block mb-2" href="#">Apply </a>}
           {item.institutestatus == 1 ?<a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Not Verified</a>:
           item.institutestatus == 2 ? <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Verified</a>:
           <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Rejected</a>}
           </div>
         </div> */}
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };
  const to = (page - 1) * 5 + 1;
  const from = page * 5 > totalJobs ? totalJobs : page * 5;

  return (
    <>
      {loading && <Loader />}
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">JOB LIST</h4>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-black font-weight-bold">
          {totalJobs} Jobs & Vacancies
        </p>
        <p className="text-secondary">
          Jobs {to} to {from} of {totalJobs}
        </p>
      </div>

      <div className="row">
        <div className="col-md-3 order-sm-12">
          <div className="card formcard p-2 mb-3">
            <p className="text-black font-weight-bold table_heading position-relative">
              Filter
            </p>
            <form className="form-group">
              {roleid() != 4 ? (
                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Employer
                  </label>
                  <select
                    title="Select Company"
                    className="form-control rounded-pill"
                    onChange={(e) => setEmployer(e.target.value)}
                  >
                    <option value="">Select Employer</option>
                    {employerOptions.map((item) => (
                      <option
                        value={item.id}
                        style={{ backgroundImage: `url(${item.logo})` }}
                      >
                        {item.companyname}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}

              {roleid() != 3 ? (
                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Recruiter
                  </label>
                  <select
                    title="Select Company"
                    className="form-control rounded-pill"
                    onChange={(e) => setRecruiter(e.target.value)}
                  >
                    <option value="">Select Recruiter</option>
                    {recruiterOptions == null ? (
                      <option>Loading...</option>
                    ) : (
                      recruiterOptions.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))
                    )}
                  </select>
                </div>
              ) : null}
              <div className="form-group col-md-12">
                <label className="mb-1" for="inputEmailAddress">
                  Sector
                </label>
                <select
                  title="Select Company"
                  className="form-control rounded-pill"
                  onChange={(e) => clickSector(e.target.value)}
                >
                  <option value="">Select Sector</option>
                  {sectorOptions == null ? (
                    <option>Loading...</option>
                  ) : (
                    sectorOptions.map((item) => (
                      <option value={item.id}>{item.sectorname}</option>
                    ))
                  )}
                </select>
              </div>
              <div className="form-group col-md-12">
                <label className="small mb-1" for="inputPassword">
                  Location
                </label>
                <Typeahead
                  className="rounded-pill "
                  id="basic-typeahead-multiple"
                  labelKey="name"
                  multiple
                  onChange={clickLocations}
                  options={locOptions}
                  placeholder="Choose location..."
                  selected={jobLocation}
                />{" "}
              </div>

              <div className="form-group col-md-12">
                <label className="small mb-1" for="inputPassword">
                  Courses
                </label>
                <Typeahead
                  className="rounded-pill "
                  id="Courses"
                  labelKey="name"
                  multiple
                  onChange={clickCourses}
                  options={courseOptions}
                  placeholder="Choose Courses ..."
                  selected={courses}
                />
              </div>
              <div className="form-group col-md-12">
                <label className="small mb-1" for="inputPassword">
                  Skills
                </label>
                <Typeahead
                  className="rounded-pill "
                  id="Skills"
                  labelKey="name"
                  multiple
                  onChange={clickSkills}
                  options={skillOptions}
                  placeholder="Choose skills ..."
                  selected={skills}
                />
              </div>
              {/* <div className="form-group col-md-12">
                <button className="btn btn-primary-custom mr-1">Apply</button>
                <button className="btn btn-secondary-custom">Reset</button>
              </div> */}
            </form>
          </div>
        </div>
        <div className="col-md-9 order-sm-1">
          {jobList ? renderJob() : <></>}
          <ul className="d-flex justify-content-between list-unstyled pagination">
            <li className="px-3">
              {page == 1 ? (
                <a className="d-none">
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              ) : (
                <a onClick={(e) => changePage(-1)}>
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              )}
            </li>

            <li className="px-3">
              {jobList && jobList.length < 5 ? (
                <a className="d-none">
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              ) : (
                <a onClick={(e) => changePage(1)}>
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              )}
            </li>
          </ul>
        </div>
      </div>

    </>
  );
};
export default ListJob;
